const Experiences = ({ companyName, position, date, location , job }) => {
    const isRecent = date.toLowerCase().includes('recent');

    return (
      <article className={`experience-box ${isRecent ? 'is-recent' : ''}`}>
        <div className="experience-header">
          <div>
            <h3>{companyName}</h3>
            <h4>{position}</h4>
          </div>
          <p className="experience-meta">{date}, {location}</p>
        </div>
        <p className="ex-info">
            {job}
        </p>
      </article>
    );
  };
  

export default Experiences;
